import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { MyStore, reducers } from 'kts-platform-frame/redux';
import EditQualification from './UI.Edit';
import moment from 'moment';
import {
    Button,
    Table,
    Modal,
    Icon
}  from 'antd';


const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
    
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
        ModulesAction.getQualificationList();
    }
    
    render() {
        const columns = [
            {
                title: '资质编号',
                dataIndex: 'code'
            },
            {
                title: '资质名称',
                dataIndex: 'name'
            },
            {
                title: '所属行业',
                dataIndex: 'industry'
            },
            {
                title: '资质有效期',
                dataIndex: 'endTime',
                render: (text, record) => {
                    const { startTime, endTime } = record;
                    return (
                        <span>
                            {
                                startTime && moment(startTime).format('ll')
                            }
                            {
                                (startTime || endTime) && ' 至 '
                            }
                            {
                                endTime && moment(endTime).format('ll')
                            }
                        </span>
                    );
                }
            },
            {
                title: '操作',
                render: (text, record) => {
                    return (
                        <div className={css['table-operate']}>
                            <a
                                onClick={
                                    () => {
                                        ModulesAction.getQualificationInfo({qualificationId: record.qualificationId});
                                        this.editQualificaton(1, record.qualificationId);
                                    }
                                }
                            >
                                查看
                            </a>
                            <a
                                onClick={
                                    () => {
                                        this.changeDeleteVisible(true);
                                        ModulesAction.changeWillDeleteQulification(record);
                                    }
                                }
                            >
                                删除
                            </a>
                        </div>
                    );
                }
            }
        ];
        const qualificationList = this.modulesState.qualificationList;
        return (
            <div className={css.qualification}>
                <header className={css['qualification-header']}>
                    <Button
                        type="primary"
                        icon="plus"
                        onClick={() => {
                            this.editQualificaton(0);
                        }}
                    >
                        新增资质
                    </Button>
                </header>
                <Table
                    className={`${css['table']} kts-app-ant-table`}
                    columns={columns}
                    bordered={true}
                    dataSource={qualificationList}
                    pagination={false}
                >
                </Table>
                <Modal
                    title="删除资质"
                    visible={this.modulesState.deleteVisible}
                    onOk={this.deleteQualificationSure}
                    onCancel={this.deleteQualificationCancel}
                    className='kts-app-ant-modal'
                >
                    <p><Icon type="zhuyi"/>你确认删除{this.modulesState.willDeleteQualification.name}吗？</p>
                </Modal>
            </div>
        );
    }

    private editQualificaton = (type?: number, id?: string) => {
        const title = (type === 0) ? '新增资质' : '查看资质';
        // MyStore.instance.dispatch(reducers.aside.ActionTypes.show, {
        //     Components: <EditQualification type={type} id={id}/>,
        //     title: title
        // });
        MyStore.instance.dispatch(reducers.rightPopUps.ActionTypes.add, {
            Components: <EditQualification type={type} id={id}/>,
            title: title
        });
    }

    private deleteQualificationSure = () => {
        const option = {
            qualificationId: this.modulesState.willDeleteQualification.qualificationId
        };
        ModulesAction.deleteQualification(option)
        .then(res => {
            this.changeDeleteVisible(false);
        });
    }

    private deleteQualificationCancel = () => {
        this.changeDeleteVisible(false);
    }

    private changeDeleteVisible = (b) => {
        ModulesAction.changeDeleteVisible(b);
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/CompanyInfo/Qualification/UI.Components.tsx